import {
    XMarkIcon,
    PhoneIcon,
    CalendarDaysIcon,
    ClockIcon,
    UserIcon,
    InformationCircleIcon,
    BuildingOffice2Icon,
    ClipboardDocumentListIcon,
} from '@heroicons/react/24/outline';

// Modal de detalle de cita, reutilizado en la Bitácora y en el Chat de WhatsApp
const AppointmentDetailModal = ({ appointment, onClose }) => {
    if (!appointment) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            {/* Backdrop */}
            <div className="absolute inset-0 bg-black/40" onClick={onClose} />

            {/* Panel */}
            <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 overflow-hidden">
                {/* Header */}
                <div className="flex items-center justify-between px-5 py-4 bg-[#3c4d69]">
                    <div className="flex items-center gap-2 text-white font-semibold">
                        <CalendarDaysIcon className="h-5 w-5" />
                        Detalle de Cita #{appointment.id}
                    </div>
                    <button onClick={onClose} className="text-white/80 hover:text-white transition-colors cursor-pointer">
                        <XMarkIcon className="h-5 w-5" />
                    </button>
                </div>

                {/* Body */}
                <div className="px-5 py-4 space-y-3 text-sm">
                    {/* Paciente */}
                    <div className="flex items-start gap-3 py-2 border-t border-gray-100">
                        <UserIcon className="h-5 w-5 text-gray-400 shrink-0 mt-0.5" />
                        <div>
                            <p className="text-gray-500 text-xs">Paciente</p>
                            <p className="font-medium text-gray-900">{appointment.nombre_paciente || '—'}</p>
                        </div>
                    </div>

                    {/* Teléfono */}
                    <div className="flex items-start gap-3 py-2 border-t border-gray-100">
                        <PhoneIcon className="h-5 w-5 text-gray-400 shrink-0 mt-0.5" />
                        <div>
                            <p className="text-gray-500 text-xs">Teléfono</p>
                            <p className="font-medium text-gray-900">{appointment.telefono_paciente || '—'}</p>
                        </div>
                    </div>

                    {/* Fecha y hora */}
                    <div className="flex gap-4 py-2 border-t border-gray-100">
                        <div className="flex items-start gap-3 flex-1">
                            <CalendarDaysIcon className="h-5 w-5 text-gray-400 shrink-0 mt-0.5" />
                            <div>
                                <p className="text-gray-500 text-xs">Fecha</p>
                                <p className="font-medium text-gray-900">{appointment.fecha || '—'}</p>
                            </div>
                        </div>
                        <div className="flex items-start gap-3 flex-1">
                            <ClockIcon className="h-5 w-5 text-gray-400 shrink-0 mt-0.5" />
                            <div>
                                <p className="text-gray-500 text-xs">Hora</p>
                                <p className="font-medium text-gray-900">{appointment.hora || '—'}</p>
                            </div>
                        </div>
                    </div>

                    {/* Doctor */}
                    {appointment.doctor && (
                        <div className="flex items-start gap-3 py-2 border-t border-gray-100">
                            <UserIcon className="h-5 w-5 text-gray-400 shrink-0 mt-0.5" />
                            <div>
                                <p className="text-gray-500 text-xs">Doctor</p>
                                <p className="font-medium text-gray-900">{appointment.doctor}</p>
                            </div>
                        </div>
                    )}

                    {/* Origen */}
                    {appointment.source && (
                        <div className="flex items-start gap-3 py-2 border-t border-gray-100">
                            <InformationCircleIcon className="h-5 w-5 text-gray-400 shrink-0 mt-0.5" />
                            <div>
                                <p className="text-gray-500 text-xs">Origen</p>
                                <p className="font-medium text-gray-900">{appointment.source}</p>
                            </div>
                        </div>
                    )}

                    {/* Sucursal */}
                    {appointment.sucursal?.nombre_sucursal && (
                        <div className="flex items-start gap-3 py-2 border-t border-gray-100">
                            <BuildingOffice2Icon className="h-5 w-5 text-gray-400 shrink-0 mt-0.5" />
                            <div>
                                <p className="text-gray-500 text-xs">Sucursal</p>
                                <p className="font-medium text-gray-900">{appointment.sucursal.nombre_sucursal}</p>
                            </div>
                        </div>
                    )}

                    {/* Servicios / estudios (solo disponible cuando viene del chat de WhatsApp) */}
                    {appointment.servicios?.length > 0 && (
                        <div className="flex items-start gap-3 py-2 border-t border-gray-100">
                            <ClipboardDocumentListIcon className="h-5 w-5 text-gray-400 shrink-0 mt-0.5" />
                            <div>
                                <p className="text-gray-500 text-xs">Servicios</p>
                                <p className="font-medium text-gray-900">{appointment.servicios.join(', ')}</p>
                            </div>
                        </div>
                    )}

                    {/* Observaciones */}
                    {appointment.observaciones && (
                        <div className="py-2 border-t border-gray-100">
                            <p className="text-gray-500 text-xs mb-1">Observaciones</p>
                            <p className="text-gray-700">{appointment.observaciones}</p>
                        </div>
                    )}
                </div>

                {/* Footer */}
                <div className="px-5 py-3 bg-gray-50 border-t border-gray-100 flex justify-end">
                    <button
                        onClick={onClose}
                        className="px-4 py-1.5 text-sm bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-md transition-colors cursor-pointer"
                    >
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AppointmentDetailModal;
